export const invoiceTemplateConfig = {
  colors: {
    primary: '#1a1a1a', // Dark theme primary
    secondary: '#667eea', // Brand blue
    accent: '#f8fafc', // Light background
    text: {
      main: '#1a202c',
      muted: '#64748b',
      white: '#ffffff',
    },
    status: {
      delivered: { bg: '#dcfce7', text: '#166534' },
      pending: { bg: '#fef3c7', text: '#92400e' },
      in_transit: { bg: '#dbeafe', text: '#1e40af' },
      cancelled: { bg: '#fee2e2', text: '#991b1b' },
    },
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: {
      title: '24px',
      heading: '18px',
      body: '14px',
      small: '12px',
    },
  },
  layout: {
    sidebarWidth: '300px',
    padding: '40px',
    borderRadius: '12px',
  },
};
